module.exports = __webpack_public_path__ + "img/bsquadron3.2b318d96.png";